import logo_meditong from "@img/logo/logo_meditong.png";
import logo_aide from "@img/logo/logo_aide.png";
import logo_aide_white from "@img/logo/logo_aide_white.png";
import logo_svg from "@img/icon/icon_aideLogo_small.svg";
import logo_svg_white from "@img/icon/icon_aideLogo_small_white.svg";
import logo_onmaum from "@img/logo/logo_onmaum.png";
import logo_seosan from "@img/logo/logo_seosan.jpg";

import text_ai_color from "@img/logo/titleAI_color.svg";
import text_ai_white from "@img/logo/titleAI_white.svg";

import user from "@img/icon/icon_user.svg";
import user_white from "@img/icon/icon_user_white.svg";
import user_black from "@img/icon/icon_user_black.svg";

import icon_service_roster from "@img/icon/icon_service_roster.svg";
import icon_calendar_gray from "@img/icon/icon_calendar_gray.svg";
import icon_calendar_blue from "@img/icon/icon_calendar_blue.svg";

import icon_chevron_toDown_black from "@img/icon/icon_chevron_toDown_black.png";
import icon_pencil_gray from "@img/icon/icon_pencil_gray.png";
import icon_pencil_black from "@img/icon/icon_pencil_black.png";
import icon_handle from "@img/icon/icon_handle.svg";
import icon_download from "@img/icon/icon_download.svg";
import icon_share from "@img/icon/icon_share.svg";

import dashboard from "@img/pic/dashboardTemp.png";
import icon_excel from "@img/icon/icon_excel.svg";

import icon_lock from "@img/icon/icon_lock.svg";
import icon_tooltip from "@img/icon/icon_tooltip.png";
import icon_search from "@img/icon/icon_search.png";
import icon_plus from "@img/icon/icon_plus.png";
import icon_person from "@img/icon/icon_person.png";
import icon_person_black from "@img/icon/icon_person_black.png";
import icon_grade_setting_blue from "@img/icon/icon_grade_setting_blue.svg";
import icon_chevron_down_fill_gray from "@img/icon/icon_chevron_down_fill_gray.svg";
import icon_close_gray from "@img/icon/icon_close_gray.svg";
import icon_lock_white from "@img/icon/icon_lock_white.svg";
import icon_circle_check from "@img/icon/icon_circle_check.svg";
import icon_logo_medium from "@img/icon/icon_logo_medium.svg";
import icon_chevron_toDown_lingtgray from "@img/icon/icon_chevron_toDown_lingtgray.svg";
import profile_girl from "@img/pic/profile_girl.png";
import profile_boy from "@img/pic/profile_boy.png";
import icon_camera from "@img/icon/icon_camera.svg";
import icon_emoji_1 from "@img/icon/icon_emoji_1.svg";
import icon_emoji_2 from "@img/icon/icon_emoji_2.svg";
import icon_emoji_3 from "@img/icon/icon_emoji_3.svg";
import icon_emoji_4 from "@img/icon/icon_emoji_4.svg";
import icon_emoji_5 from "@img/icon/icon_emoji_5.svg";
import icon_emoji_6 from "@img/icon/icon_emoji_6.svg";
import icon_thin_close from "@img/icon/icon_thin_close.svg";
import icon_pencil from "@img/icon/icon_pencil.svg";
import icon_plus_btn from "@img/icon/icon_plus_btn.svg";
import icon_copy from "@img/icon/icon_copy.svg";
import icon_grid_gray_circle from "@img/icon/icon_grid_gray_circle.svg";
import icon_grid_blue_circle from "@img/icon/icon_grid_blue_circle.svg";
import icon_setting_gray_circle from "@img/icon/icon_setting_gray_circle.svg";
import icon_checkbox_fill_gray from "@img/icon/icon_checkbox_fill_gray.svg";
import icon_checkbox_gray from "@img/icon/icon_checkbox_gray.svg";
import icon_checkbox_circle_blue from "@img/icon/icon_checkbox_circle_blue.svg";


export const images = {
  logo_meditong,
  logo_aide,
  logo_aide_white,
  logo_svg,
  logo_svg_white,
  logo_onmaum,
  logo_seosan,

  text_ai_color,
  text_ai_white,

  user,
  user_white,
  user_black,
  icon_service_roster,
  icon_calendar_gray,
  icon_calendar_blue,

  icon_chevron_toDown_black,

  icon_pencil_gray,
  icon_pencil_black,

  icon_handle,
  icon_download,
  icon_share,

  dashboard,
  icon_excel,

  icon_lock,
  icon_tooltip,
  icon_search,
  icon_plus,
  icon_person,
  icon_person_black,
  icon_grade_setting_blue,
  icon_chevron_down_fill_gray,
  icon_close_gray,
  icon_lock_white,
  icon_circle_check,
  icon_logo_medium,
  icon_chevron_toDown_lingtgray,

  profile_girl,
  profile_boy,
  icon_camera,
  icon_emoji_1,
  icon_emoji_2,
  icon_emoji_3,
  icon_emoji_4,
  icon_emoji_5,
  icon_emoji_6,
  icon_thin_close,
  icon_pencil,
  icon_plus_btn,
  icon_copy,
  icon_grid_gray_circle,
  icon_grid_blue_circle,
  icon_setting_gray_circle,

  icon_checkbox_fill_gray,
  icon_checkbox_gray,
  icon_checkbox_circle_blue
};
